'use strict';

/**
 * @function
 * @description
 * @param {String}
 * @param {String}
 */
const elementInViewport = (el, offsetToTop) => {
    const rect = el.getBoundingClientRect();
    const offsetTop = offsetToTop || 0;

    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = ((rect.top - offsetTop) <= windowHeight) && (((rect.top - offsetTop) + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
};

module.exports = elementInViewport;
